import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    isChecked: false,
    finalPayableAmount: 0,
};
const walletSlice = createSlice({
    name: "wallet",
    initialState,
    reducers: {
        setWalletFlag: (state, action) => {
            state.isChecked = action.payload;
        },
        resetWalletFlag: () => {
            return initialState;
        },
        setFinalPayableAmount: (state, action) => {
            state.finalPayableAmount = action.payload;
        },

    },
});
export const { setWalletFlag, resetWalletFlag, setFinalPayableAmount } = walletSlice.actions;
export default walletSlice.reducer;